import { lazy } from 'react';

const SetAsGoalModal = lazy(() => import('./SetAsGoalModal'));

export default {
  SET_AS_GOAL_MODAL: SetAsGoalModal,
};
